<script lang="ts" setup>
import { API } from "@/api/api";
import { useSnackbarStore } from "@/store/snackbar.store";
import { onMounted, ref } from "vue";
import type { CarrierDto } from "@/api/company/dto/carrier.dto";

const api = new API();

const { showSnackbarError } = useSnackbarStore();

const loading = ref<boolean>(false);
const carries = ref<CarrierDto[]>([]);

const modelValue = defineModel<string | null>({ default: "" });

async function getCarries() {
  try {
    const response = await api.company.findCarriers({ pageSize: 10 });

    if (response.data && response.success) {
      carries.value = response.data.items;
    }
  } catch (error) {
    showSnackbarError("Could not get carriers");
  }
}

onMounted(async () => {
  loading.value = true;
  await getCarries();
  loading.value = false;
});
</script>

<template>
  <v-autocomplete
    v-model="modelValue"
    :items="carries"
    :loading="loading"
    clearable
    color="primary"
    density="compact"
    hide-details
    item-title="name"
    item-value="id"
    label="Carrier"
    name="carrier"
    variant="outlined"
  ></v-autocomplete>
</template>

<style lang="scss" scoped></style>
